import { render, staticRenderFns } from "./handicapGeneral.vue?vue&type=template&id=55d3540d&scoped=true"
import script from "./handicapGeneral.vue?vue&type=script&lang=js"
export * from "./handicapGeneral.vue?vue&type=script&lang=js"
import style0 from "./handicapGeneral.vue?vue&type=style&index=0&id=55d3540d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3540d",
  null
  
)

export default component.exports